import * as React from 'react';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import classnames from 'classnames';
import moment from 'moment';

import {formatTimestampForScheduledMail} from 'nutshell-core/date-time/formatting';

import {DropdownButton} from 'shells/button/dropdown-button/dropdown-button';
import type {CannedOption} from 'shells/date-time-picker/canned-options';
import {DateTimePickerPopover} from 'shells/date-time-picker/date-time-picker-popover';

import {TwoLineInfo} from './two-line-info';

import styles from './editable-date.module.css';

type Props = {
    // This is the type we get from GraphQL
    value: any | null | undefined;
    defaultDate?: Date;
    emptyText?: string;
    onUpdate: (arg1?: Date | null | undefined) => void;
    title: string;
    minDate?: Date;
    maxDate?: Date;
    warningText?: string;
    cannedOptions?: CannedOption[];
    saveDateOnYearChange?: boolean;
    isClearable?: boolean;
};
type State = {
    showDatePicker: boolean;
};

export class EditableDate extends React.PureComponent<Props, State> {
    closeDateRef: HTMLElement | null | undefined;

    static defaultProps = {
        isClearable: false,
    };

    constructor(props: Props) {
        super(props);
        this.state = {
            showDatePicker: false,
        };
    }

    componentDidMount() {
        ReactTooltip.rebuild();
    }

    render() {
        const formattedCloseDate = this.props.value
            ? formatTimestampForScheduledMail(this.props.value)
            : this.props.emptyText || '';

        const isClearable = this.props.isClearable && this.props.value;

        const styleNames = classnames(styles['clickable-date'], {
            [styles['warning-date']]: Boolean(this.props.warningText),
        });

        return (
            <TwoLineInfo
                header={this.props.title}
                body={
                    <>
                        <div
                            className={
                                isClearable ? styles['container-clearable'] : styles.container
                            }
                        >
                            <div
                                ref={(ref) => (this.closeDateRef = ref)}
                                data-tip={
                                    this.props.warningText ||
                                    (this.props.value
                                        ? moment
                                              .unix(this.props.value)
                                              .format('MMMM Do, YYYY h:mm a')
                                        : null)
                                }
                                data-place='bottom'
                                className={styleNames}
                            >
                                <DropdownButton
                                    label={formattedCloseDate || ''}
                                    onClick={() => {
                                        this.setState({showDatePicker: true});
                                    }}
                                />
                            </div>
                        </div>
                        {this.closeDateRef && this.state.showDatePicker ? (
                            <DateTimePickerPopover
                                anchor={this.closeDateRef}
                                value={
                                    this.props.value
                                        ? new Date(this.props.value * 1000)
                                        : this.props.defaultDate || new Date()
                                }
                                onCancel={() => {
                                    this.setState({showDatePicker: false});
                                }}
                                onConfirm={(value) => {
                                    this.props.onUpdate(value);
                                    this.setState({showDatePicker: false});
                                }}
                                minDate={this.props.minDate}
                                maxDate={this.props.maxDate}
                                cannedOptions={this.props.cannedOptions}
                                saveDateOnYearChange={this.props.saveDateOnYearChange}
                                onClear={
                                    this.props.isClearable && this.props.value
                                        ? () => {
                                              this.props.onUpdate(null);
                                              this.setState({showDatePicker: false});
                                          }
                                        : undefined
                                }
                            />
                        ) : undefined}
                    </>
                }
            />
        );
    }
}
